/**
 * Check if user is admin
 * @param {*} uid
 * @returns boolean
 */
export const isAdmin = uid =>
  ['bHQ9DHlO09TZ10a1Sn1b7d5CGHN2'].includes(uid) ||
  ['bibe', 'localhost'].includes(window.localStorage.getItem('tenant'))
